import RightSidePanel from "../../Components/RightSidePanel";
import SidePanel from "../../Components/SidePanel";
import TopBar from "../../Components/TopBar";
import Styles from "./LiveClasses.module.css";
import { useCallback, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { Package_List } from "../../Action/PacakgeAction";
import { FaCircleArrowLeft, FaCircleArrowRight } from "react-icons/fa6";
import PackageCard from "../../Components/PackageCard";
import Styles2 from "../Home/Home.module.css";
import Enroll from "../Home/Enroll";
import Loading from "../../Components/Loading";
import ReactHelmet from "../../Components/ReactHelmet";
import { BsCalendar3 } from "react-icons/bs";
import { BiTime } from "react-icons/bi";
import { GET_MONTH_YEAR } from "../../Model/HomeModel";
import { list_LiveClass } from "../../Action/LiveClassAction";
import Lock from "../../Components/Lock";
import { AttendanceMarked, JoinClass } from "../../Action/AttendanceAction";
import { JOIN_CLASS_RESET } from "../../Constant/AttendanceConstatnt";
import AlertPopup from "../../Components/AlertPopup";
import { toast, ToastContainer } from "react-toastify";
import { convertTo12Hour, toastOptions } from "../../Model/ToastEditiorOption";
import MobileLiveClass from "./MobileLiveClass";

export default function LiveClass() {
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const Mobile_Screen = window.innerWidth;
  const [CourseId, setCourseId] = useState("");
  const [EnrollActive, setEnrollActive] = useState(false);
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);
  const { loading: loadingPack, PackageRec } = useSelector(
    (s) => s.Package_List_Reducer
  );
  const [OpenNext, setOpenNext] = useState(false);
  const [AlertData, setAlertData] = useState({ msg: "", Alert: () => {} });
  const {
    loading: loadingUrl,
    error: errorUrl,
    Class_Link_Url,
  } = useSelector((s) => s.JoinClassReducer);

  const {
    loaidng: loadingM,
    error: errorM,
    success: successM,
  } = useSelector((s) => s.AttendanceMarkedReducer);
  const {
    loading: loadingClass,
    error: errorclass,
    classRecs,
    DemoClasses,
    MeetingData,
  } = useSelector((s) => s.list_LiveClassReducer);
  const { loading, error, batchDet } = useSelector(
    (s) => s.get_contact_batchReducer
  );

  const dispatch = useDispatch();
  const BrowsePackageRef = useRef();

  const BrowsePacakgesettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow:
      Mobile_Screen <= 480
        ? 1
        : Mobile_Screen <= 780
        ? PackageRec?.length >= 2
          ? 2
          : 1
        : PackageRec?.length >= 2
        ? 2
        : PackageRec?.length == 2
        ? 2
        : 1,
    slidesToScroll: 1,
  };

  const get_Packages = useCallback(() => {
    dispatch(Package_List({ page_size: 10, page_no: 1 }, "MainPackages"));
    dispatch(list_LiveClass());
  }, [dispatch]);

  useEffect(() => {
    get_Packages();
  }, [get_Packages]);

  useEffect(() => {
    if (errorM) {
      toast.error(errorM, toastOptions);
    }
    // setTimeout(() => {
    //   dispatch({ type: JOIN_CLASS_RESET });
    //   toast.dismiss();
    // }, 5000);
  }, [successM, errorM]);

  useEffect(() => {
    if (Class_Link_Url) {
      if (Class_Link_Url?.includes("https")) {
        window.location.href = Class_Link_Url.replace(
          "https://testifyi.com",
          ""
        );
      } else {
        toast.success(Class_Link_Url, toastOptions);
      }

      setTimeout(() => {
        dispatch({ type: JOIN_CLASS_RESET });
      }, 3000);
    }
    if (errorUrl) {
      toast.error(errorUrl, toastOptions);
    }
    setTimeout(() => {
      dispatch({ type: JOIN_CLASS_RESET });
      toast.dismiss();
    }, 5000);
  }, [errorUrl, Class_Link_Url]);

  return Mobile_Screen <= 881 ? (
    <MobileLiveClass
      batchDet={batchDet}
      DemoClasses={DemoClasses}
      classRecs={classRecs}
    />
  ) : (
    <div className={Styles.Dashboard}>
      <ReactHelmet title={"Live Classes"} description={""} />
      {/* SidePanel */}
      {loading || loadingClass ? <Loading /> : ""}

      {Mobile_Screen >= 780 ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Live Classes"
        />
      ) : (
        ""
      )}

      {Mobile_Screen <= 480 && SidebarOpen ? (
        <SidePanel
          SetSideBarOpen={SetSideBarOpen}
          SidebarOpen={SidebarOpen}
          Page="Live Classes"
        />
      ) : (
        ""
      )}

      {loadingPack || loadingM || loadingUrl ? <Loading /> : ""}

      {EnrollActive ? (
        <Enroll
          setEnrollActive={setEnrollActive}
          Package_Id={EnrollActive}
          courseId={CourseId}
        />
      ) : (
        ""
      )}
      {/* Middle Section */}

      <section className={Styles.MiddleSection}>
        <div>
          <TopBar
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            SetSideBarOpen2={setOpenMenuBar2}
            SidebarOpen2={OpenMenuBar2}
            PageName={"Live Classes"}
          />
        </div>
        {!batchDet && !DemoClasses?.length ? (
          <>
            <div className={Styles.OnlineClassTopSection}>
              <Lock />
            </div>

            <section style={{ background: "#f4f9ff", paddingBottom: "60px" }}>
              <div style={{ margin: "30px" }}>
                <div className={Styles.Browse_Package_Section}>
                  <div>
                    {" "}
                    <h1 className={Styles.Heading}>
                      <span className="Font_Rajdhani">Browse Courses </span>
                    </h1>
                    {/* <p>
                    In this free interactive webinar, our IELTS expert will help
                    us be ready to answer
                    <br /> a range of common questions types for Part 1 of the
                    Speaking Test.
                  </p>{" "} */}
                  </div>
                  <div className={Styles.Browse_Package_Scroller}>
                    <div onClick={() => BrowsePackageRef?.current?.slickPrev()}>
                      <FaCircleArrowLeft />
                    </div>
                    <div onClick={() => BrowsePackageRef?.current?.slickNext()}>
                      {" "}
                      <FaCircleArrowRight />
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ margin: "0 30px" }}>
                <Slider
                  ref={BrowsePackageRef}
                  style={{ width: "100%" }}
                  {...BrowsePacakgesettings}
                >
                  {PackageRec?.map((el, i) => (
                    <div key={i + 90}>
                      <PackageCard
                        setEnrollActive={setEnrollActive}
                        EnrollActive={EnrollActive}
                        setCourseId={setCourseId}
                        el={el}
                        Styles={Styles2}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </section>
          </>
        ) : (
          ""
        )}

        {batchDet || DemoClasses?.length ? (
          <div style={{ height: "80vh", overflow: "scroll" }}>
            {" "}
            <div className={Styles.OnlineClassTopSection}>
              <div>
                <h3>Upcoming Online Classes</h3>
                <p>
                  Stay ahead in your learning journey! Check out our upcoming
                  online classes scheduled to help you master new concepts,
                  sharpen your skills, and achieve your goals.
                </p>
              </div>
              <div>
                <select>
                  <option>This Week</option>
                </select>
              </div>
            </div>
            {classRecs?.map((el, i) => (
              <div key={i + 89273} className={Styles.OnlineClassContainer}>
                <div className={Styles.OnlineClassCard}>
                  <div>
                    <div
                      className={
                        el?.ClassType == 1 ? Styles.online : Styles.offline
                      }
                    >
                      <p>{el?.ClassType == 1 ? "Online" : "Offline"}</p>
                    </div>
                    <h4>
                      {el?.ClassName}
                      {/* <br />
                        Master Program */}
                    </h4>
                    <p>
                      Lecturer:{" "}
                      <span>
                        {" "}
                        {el?.Batch_Id?.Faculty?.First_Name
                          ? el?.Batch_Id?.Faculty?.First_Name +
                            " " +
                            el?.Batch_Id?.Faculty?.Last_Name
                          : "N/A"}{" "}
                      </span>
                    </p>
                  </div>
                  <hr />
                  <div className={Styles.ClassDate}>
                    <div>
                      <div>
                        <p>
                          <BsCalendar3 />
                        </p>
                        <p>Date</p>
                      </div>
                      <div>
                        <p>
                          {el?.DateOfClass
                            ? GET_MONTH_YEAR(el?.DateOfClass)
                            : el?.ClassDate
                            ? GET_MONTH_YEAR(el?.ClassDate)
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div>
                        <p>
                          <BiTime />
                        </p>
                        <p>Time</p>
                      </div>
                      <div>
                        <p>
                          {el?.ClassTimingFrom
                            ? convertTo12Hour(el?.ClassTimingFrom) +
                              " - " +
                              convertTo12Hour(el?.ClassTimingTo)
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr />
                  {el?.ClassType == 1 ? (
                    <div className={Styles.BtmClass}>
                      <div>
                        <h4>Live Class Link</h4>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            dispatch(
                              JoinClass(
                                {
                                  LiveClassId: el?.ClassId,
                                  TeacherId: el?.Batch_Id?.Faculty?._id,
                                  BatchId: el?.Batch_Id?._id,
                                },
                                el?.ClassId
                              )
                            );
                            // } else {
                            //   dispatch({
                            //     type: CREATE_ATTENDANCE_FAILED,
                            //     payload: "Error - Class Not Started Yet !",
                            //   });
                            // }
                          }}
                        >
                          Link
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className={Styles.BtmClass}>
                      <div>
                        <h4>Live Class Link</h4>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            dispatch(
                              JoinClass(
                                {
                                  LiveClassId: el?.ClassId,
                                  TeacherId: el?.Batch_Id?.Faculty?._id,
                                  BatchId: el?.Batch_Id?._id,
                                },
                                el?.ClassId
                              )
                            );
                            // window.location.href = el?.ClassLink;
                            // } else {
                            //   dispatch({
                            //     type: CREATE_ATTENDANCE_FAILED,
                            //     payload: "Error - Class Not Started Yet !",
                            //   });
                            // }
                          }}
                        >
                          Offline
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
            {DemoClasses?.map((el, i) => (
              <div key={i + 82273} className={Styles.OnlineClassContainer}>
                <div className={Styles.OnlineClassCard}>
                  <div>
                    <div
                      className={
                        el?.ClassType == 1 ? Styles.online : Styles.offline
                      }
                    >
                      <p>{el?.ClassType == 1 ? "Online" : "Offline"}</p>
                    </div>
                    <h4>
                      {el?.ClassName}
                      {/* <br />
                        Master Program */}
                    </h4>
                    <p>
                      Lecturer:{" "}
                      <span>
                        {" "}
                        {el?.Trainer_Id?.First_Name
                          ? el?.Trainer_Id?.First_Name +
                            " " +
                            el?.Trainer_Id?.Last_Name
                          : "N/A"}{" "}
                      </span>
                    </p>
                  </div>
                  <hr />
                  <div className={Styles.ClassDate}>
                    <div>
                      <div>
                        <p>
                          <BsCalendar3 />
                        </p>
                        <p>Date</p>
                      </div>
                      <div>
                        <p>
                          {el?.DateOfClass
                            ? GET_MONTH_YEAR(el?.DateOfClass)
                            : el?.ClassDate
                            ? GET_MONTH_YEAR(el?.ClassDate)
                            : ""}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div>
                        <p>
                          <BiTime />
                        </p>
                        <p>Time</p>
                      </div>
                      <div>
                        <p>
                          {el?.ClassTimingFrom
                            ? convertTo12Hour(el?.ClassTimingFrom) +
                              " - " +
                              convertTo12Hour(el?.ClassTimingTo)
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr />
                  {el?.ClassType == 1 ? (
                    <div className={Styles.BtmClass}>
                      <div>
                        <h4>Live Class Link</h4>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            dispatch(
                              JoinClass(
                                {
                                  LiveClassId: el?.ClassId,
                                  TeacherId: el?.Batch_Id?.Faculty?._id,
                                  BatchId: el?.Batch_Id?._id,
                                  Demo: true,
                                },
                                el?.ClassId
                              )
                            );
                            // } else {
                            //   dispatch({
                            //     type: CREATE_ATTENDANCE_FAILED,
                            //     payload: "Error - Class Not Started Yet !",
                            //   });
                            // }
                          }}
                        >
                          Link
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className={Styles.BtmClass}>
                      <div>
                        <h4>Live Class Link</h4>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            dispatch(
                              JoinClass(
                                {
                                  LiveClassId: el?.ClassId,
                                  TeacherId: el?.Batch_Id?.Faculty?._id,
                                  BatchId: el?.Batch_Id?._id,
                                  Demo: true,
                                },
                                el?.ClassId
                              )
                            );
                            // window.location.href = el?.ClassLink;
                            // } else {
                            //   dispatch({
                            //     type: CREATE_ATTENDANCE_FAILED,
                            //     payload: "Error - Class Not Started Yet !",
                            //   });
                            // }
                          }}
                        >
                          Offline
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          ""
        )}

        {/* <div className={Styles.OnlineClassTopSection}>
            <div>
              <h3>Upcoming Mock Test</h3>
              <p>
                IELTS is an English language test for study, migration or work.
                Over three million people take out test every year. IELTS is
                accepted by more than 11,000 employers, universities & schools
                around the world.
              </p>
            </div>
            <div>
              <select>
                <option>This Week</option>
              </select>
            </div>
          </div> */}

        {/* <div
            style={{ display: "flex", justifyContent: "flex-end" }}
            className={Styles.DashboardBtn}
          >
            <button
              onClick={() => Navigate("/T-LAT")}
              className={Styles.custom_btn}
            >
              Start Test
            </button>
          </div>
          <div>
            <div className={Styles.UpcomingMock_Test_Card}>
              <div className={Styles.TopSection}>
                <div>
                  <p>Package Name</p>
                  <h4>
                    IELTS Academic and IELTS General <br />
                    Training Mock Test.
                  </h4>
                </div>
                <div>
                  <p>Other Links</p>
                  <div className={Styles.DashboardBtn}>
                    <button>Course Material</button>
                    <button>Cheat Sheet</button>
                  </div>
                </div>
              </div>

              <div className={Styles.IncludeTest}>
                <p>Included Mock Test:</p>
              </div>

              <div className={Styles.MockCardTest}>
                <div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package2}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package1}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package1}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package2}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div></div>
                <div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package2}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package1}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package1}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>
                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package2}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        {/*  2nd design section card mock test */}

        {/* <div>
            <div className={Styles.UpcomingMock_Test_Card}>
              <div className={Styles.TopSection}>
                <div>
                  <p>Package Name</p>
                  <h4>
                    IELTS Academic and IELTS General <br />
                    Training Mock Test.
                  </h4>
                </div>
                <div>
                  <p>Other Links</p>
                  <div className={Styles.DashboardBtn}>
                    <button>Course Material</button>
                    <button>Cheat Sheet</button>
                  </div>
                </div>
              </div>
              <div className={Styles.IncludeTest}>
                <p>Included Mock Test:</p>
              </div>
              <div className={Styles.MockCardTest}>
                <div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package2}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>
                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package1}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div></div>
                <div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package2}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                  <div className={Styles.Internal_Mock_Card}>
                    <div>
                      <p className={Styles.package1}>Paper Pen</p>
                      <p>-</p>
                      <p className={Styles.MockTest01}>Writing Mock Test 01</p>
                    </div>

                    <div>
                      <p>
                        <hr />
                      </p>
                    </div>
                    <div className={Styles.ViewTest}>
                      <p>View Test</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
      </section>

      {/* {Mobile_Screen <= 480 ? (
        <RightSidePanel
          SetSideBarOpen={setOpenMenuBar2}
          SidebarOpen={OpenMenuBar2}
        />
      ) : (
        <RightSidePanel
          SetSideBarOpen={setOpenMenuBar2}
          SidebarOpen={OpenMenuBar2}
        />
      )} */}
      <RightSidePanel
        SetSideBarOpen={setOpenMenuBar2}
        SidebarOpen={OpenMenuBar2}
      />
      <div
        onClick={() => {
          SetSideBarOpen(false);
          setOpenMenuBar2(false);
        }}
        className={SidebarOpen || OpenMenuBar2 ? "overlay active" : "overlay"}
        id="overlay"
      ></div>
      <AlertPopup
        OpenNext={OpenNext}
        setOpenNext={setOpenNext}
        AlertData={AlertData}
      />
      <ToastContainer />
      {/* Right Section  */}
    </div>
  );
}
